import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router';
import Spinner from '../layouts/Spinner';
import ProfileTop from './ProfileTop';
import ProfileAbout from './ProfileAbout';
import ProfileExperience from './ProfileExperience';
import ProfileEducation from './ProfileEducation';
import ProfileGithub from './ProfileGithub';
import { getProfileById } from '../../actions/profile'

const Profile = ({
  getProfileById, 
  profile: { profile },
  auth,
}) => {
  const { id } = useParams();
  useEffect(() => {
    getProfileById(id);
  }, [getProfileById, id])
  return (
    profile === null ? 
      <Spinner /> :
      (
        <Fragment>
          <Link to="/dev/profiles" className="btn btn-light">Back to Profiles</Link>
          {auth.isAuthenticated && !auth.loading && auth.user._id === profile.user._id && 
            (<Link to="/dev/edit-profile" className="btn btn-dark">Edit Profile</Link>)}
          <div class="profile-grid my-1">
            <ProfileTop profile={profile} />
            <ProfileAbout profile={profile} />
            <div className="profile-exp bg-white p-2">
              <h2 class="text-primary-app">Experience</h2>
              {profile.experience.length > 0 
                ? (
                  <Fragment>
                    {profile.experience.map(exp => (
                      <ProfileExperience key={exp._id} experience={exp} />
                    ))}
                  </Fragment>
                ) 
                : (<h4>No experience credentials</h4>)}
            </div>
            <div className="profile-edu bg-white p-2">
              <h2 class="text-primary-app">Education</h2>
              {profile.education?.length > 0 
                ? (
                  <Fragment>
                    {profile.education.map(edu => (
                      <ProfileEducation key={edu._id} education={edu} />
                    ))}
                  </Fragment>
                ) 
                : (<h4>No education credentials</h4>)}
            </div>

            {profile.githubusername && (
              <ProfileGithub username={profile.githubusername} />
            )}           
          </div>
        </Fragment>
      )
  )
}

Profile.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  profile: state.profile,
  auth: state.auth,
})

export default connect(mapStateToProps, { getProfileById })(Profile);